<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setLocaleToPath } from './setup/i18n';
export default {
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store')),
        ),
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
      sessionStorage.removeItem('comeFrom');
    });
  },
};
</script>

<style lang="less">
@import '~@/assets/less/app.less';
#app {
  color: #2c3e50;
  font-size: 14px;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial,
    sans-serif;
  line-height: 20px;
  background: #f8f8f8;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.clearfix:after,
#container:after {
  display: block;
  clear: both;
  height: 0;
  content: '.';
  visibility: hidden;
}
.clearfix,
#container {
  display: block;
}
* html .clearfix,
* html #container {
  height: 1%;
}
.clear {
  clear: both;
}
.el-menu--horizontal {
  .el-menu--popup {
    min-width: 104px !important;
    margin-top: 0 !important;
    padding: 10px 0 !important;
    border-radius: 0 !important;
    li {
      height: 30px !important;
      padding: 0 20px !important;
      line-height: 30px !important;
      text-align: center;
      i {
        font-weight: normal !important;
        font-size: 14px !important;
      }
    }
    .is-active {
      background: none !important;
      &:hover {
        background: none !important;
      }
      a {
        i {
          color: #31a775 !important;
        }
      }
    }
  }
}
.el-loading-spinner .path {
  stroke: #31a775 !important;
}
.el-loading-spinner .el-loading-text {
  color: #31a775 !important;
}
.el-dialog__body .text-center {
  text-align: center;
}
</style>
